import * as c from '../constants/TabConstants'

const initialState = {
  tabs: {},
  fetching: false,
  updating: false,
  updated: false,
  fetched: false,
  error: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_APPROVALS_TAB_COUNTS_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_APPROVALS_TAB_COUNTS_FULFILLED:
      return { ...state, fetching: false, fetched: true, tabs: { ...state.tabs, ...payload }}

    case c.FETCH_APPROVALS_TAB_COUNTS_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    case c.UPDATE_APPROVALS_TAB_COUNTS_PENDING:
      return { ...state, updating: true, updated: false, error: null }

    case c.UPDATE_APPROVALS_TAB_COUNTS_FULFILLED:
      return { ...state, updating: false, updated: true, tabs: { ...state.tabs, ...payload } }

    default:
      return state
  }
}
